export default {
  DEFAULT_SEARCH_PER_BASE: {
    22801201: {
      F_2: '*',
    },
  },

  override_all: {
    DASHBOARDS_PARAMS_PER_BASE: {
      default: {
        COOCCURRENCES_FIELDS: [
          { name: 'Personnes', value: 'QES_Person.verbatim', active: true },
          { name: 'Sociétés', value: 'QES_Company.verbatim', active: true },
          { name: 'Concepts', value: 'QES_Concept.verbatim', active: true },
          { name: 'Organisations', value: 'QES_Organization.verbatim', active: true },
          { name: 'Evènements', value: 'QES_Event.verbatim', active: true },
          { name: 'Produits', value: 'QES_Product.verbatim', active: true },
          { name: 'Stupéfiants', value: 'QES_Stupefiants.verbatim', active: true },
        ],
      },
    },
  },

  DYNAMIC_DASHBOARDS: true,
};
